/**
 * Lightweight trailing-edge throttle for high-frequency DOM events.
 * Drops intermediate calls, only executes at most once per `intervalMs`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function throttle<T extends (...args: any[]) => void>(fn: T, intervalMs: number): T {
  let lastCall = 0;
  return ((...args: Parameters<T>) => {
    const now = performance.now();
    if (now - lastCall >= intervalMs) {
      lastCall = now;
      fn(...args);
    }
  }) as unknown as T;
}
